import requests from "./httpService";


const UnitConversionServices = {
    getAllUnit: async () => {
        return requests.get(`/unitConversion`);
    },

    createConversion: async (body) => {
        return requests.post(`/unitConversion`, body);
    },

    byPartAndUnit: async ({
    masterPart,
    fromUnit,
    toUnit
}) => {
    return requests.get("/unitConversion/byPartAndUnit", {
        params: {
            masterPart,
            fromUnit,
            toUnit
        }
    });
},

    deleteConversion: async (id) => {
        return requests.delete(`/unitConversion/${id}`);
    },

}

export default UnitConversionServices;